import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import CostCenterForm from '../Forms/CostCenterForm';

const AddEditCostCenterModal = ({
	dataCostCenter,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Centro de Costo
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información General
						</NavLink>
					</NavItem>
				</Nav>
			</div>

			<CostCenterForm
				dataCostCenter={dataCostCenter}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditCostCenterModal;
